@if (isDesktop()) {
  <iw-logo />
}

<div class="user-info" [class.desktop]="isDesktop()">
  <iw-currency-rate class="currency" />
  <iw-user-card-small class="user-card" [userProfile]="userProfile()" />

  @if (isDesktop()) {
    <iw-button uiType="primary" size="s" iconName="logout" (click)="logout()">
      {{ "user.logOut" | translate }}
    </iw-button>
  }
</div>
